import React from "react";
import clsx from "clsx";

const Grid = ({ children, numCols = 3, className = "" }) => {
  // const baseCols = {
  //   1: "grid-cols-1",
  //   2: "grid-cols-2",
  //   3: "grid-cols-3",
  //   4: "grid-cols-4",
  //   5: "grid-cols-5",
  //   6: "grid-cols-6",
  // };

  return (
    <div
      className={clsx(
        "grid gap-2 w-full",
        "grid-cols-2", // XS fallback
        numCols >= 2 && "sm:grid-cols-2",
        numCols >= 3 && "md:grid-cols-3",
        numCols >= 4 && "lg:grid-cols-4",
        numCols >= 5 && "xl:grid-cols-5",
        numCols >= 6 && "2xl:grid-cols-6",
        className,
      )}
    >
      {children}
    </div>
  );
};

export default Grid;
